import React from 'react';
import './App.css';
import ChromosomeSwiper from './ChromosomeSwiper'

function App() {
  return (
    <div className="App">
        <div className="navbar">
          <a href="/">B-Chromosome database for plants</a>
        </div>
        <ChromosomeSwiper></ChromosomeSwiper>
    </div>
  );
}

export default App;
